import { find } from './generic';
import { onDemandPaymentFields } from './metadata/payments';
import { userFields } from './metadata/users';

export {
  fetchOnDemandPayments,
};

export const onDemandPaymentsOptions = {
  managedFields: [],
  route: `/airtable/OnDemandPayments/Payments`,
};

async function fetchOnDemandPayments(user) {
  const userID = user?.airtable?.fields[userFields.USER_ID];

  if (userID) {
    const filter = `{${onDemandPaymentFields.USER_ID}} = ${userID}`;
    return find(onDemandPaymentsOptions, filter);
  }

  return [];
}
